import { isFullscreenObs, offFullscreenChange } from "@/components/pages/live/Player/helper/player.utils";
import cn from "@/utils/mergeClassNames";
import { CloseCircle } from "iconsax-react";
import { useEffect, useState, type PropsWithChildren, type ReactNode } from "react";
import { createPortal } from "react-dom";

type Props = {
  isOpen: boolean;
  className?: string;
  children: ReactNode;
  actions?: ReactNode;
  placement?: "top" | "middle" | "bottom";
  onClose?: () => void;
  cover?: ReactNode;
  closeButton?: boolean;
  inlineClose?: boolean;
};

export default function LegacyModal({
  isOpen,
  children,
  actions,
  onClose,
  className,
  placement,
  cover,
  closeButton = true,
  inlineClose = false,
}: PropsWithChildren<Props>) {
  const [container, setContainer] = useState(document.body);

  useEffect(() => {
    const fn = isFullscreenObs((isFullscreen) => {
      if (isFullscreen) {
        const videoWrapperDialogAnchor = document.querySelector("#fullscreen-dialog-anchor") as HTMLElement | null;
        setContainer(videoWrapperDialogAnchor ?? document.body);
      } else {
        setContainer(document.body);
      }
    });

    return () => {
      offFullscreenChange(fn);
    };
  }, []);

  return isOpen
    ? createPortal(
        <dialog
          onClick={(e) => {
            e.stopPropagation();
          }}
          className={cn("modal modal-open", {
            "modal-top justify-items-center": placement === "top",
            "modal-bottom justify-items-center": placement === "bottom",
          })}>
          <div className="col-start-1 row-start-1 mx-5 flex flex-col items-center gap-6">
            <div className="relative rounded-2xl shadow">
              {cover}

              <div
                className={cn(
                  "bg-neutral-0 no-scrollbar web:py-8 flex w-full flex-col items-center gap-2 rounded-b-2xl p-6 first:rounded-t-2xl",
                  className,
                )}>
                {children}

                {actions && <div className="modal-action mt-2 w-full">{actions}</div>}
              </div>

              {onClose && closeButton && inlineClose && (
                <button type="button" className="absolute top-0 right-0 pt-3 pr-6" onClick={onClose}>
                  {/* <CloseCircle size={40} className="text-metal-300" variant="Outline" color="currentColor" /> */}
                  <span className="text-metal-600 font-sans text-[20px] font-bold">x</span>
                </button>
              )}
            </div>

            {onClose && closeButton && !inlineClose && (
              <button type="button" className="rounded-full" onClick={onClose}>
                <CloseCircle size={40} className="text-white" variant="Bold" color="currentColor" />
              </button>
            )}
          </div>

          <div className="modal-backdrop bg-neutral-800/50" onClick={onClose} />
        </dialog>,
        container,
      )
    : null;
}
